const InternationalStudents = () =>
{
    return(
    <>
    <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">International Students</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    International Students
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    {/* <div className="container-fluid bg-light py-5">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-3 col-md-6 text-center">
                    <div className="international-stats">
                        <div className="stat-number">85+</div>
                        <div className="stat-label">Countries Represented</div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6 text-center">
                    <div className="international-stats">
                        <div className="stat-number">24/7</div>
                        <div className="stat-label">Student Support</div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 text-center">
                    <div className="international-stats">
                        <div className="stat-number">95%</div>
                        <div className="stat-label">Visa Success Rate</div>
                    </div>
                </div>
            </div>
        </div>
    </div> */}

    <div className="container-xxl py-5" id="requirements">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3">Admission Process</h6>
                <h1 className="mb-5">International Admission Requirements</h1>
            </div>
            
            <div className="row g-4">
                <div className="col-lg-6">
                    <div className="requirement-card">
                        <h5><i className="fa fa-graduation-cap text-primary me-2"></i>Academic Requirements</h5>
                        <ul className="mt-3">
<li>Majority of our students come from outside India, which makes SK Educational Society an exceptionally diverse and cosmopolitan place to study.Every year number of countries represented at the Academy continues to expand- we currently represent over 14 different countries from around the world. It has students from Saudi Arabia, Iran, Iraq, Mongolia, Bahrain, Korea, Yemen, Libya, China, Thailand, Oman, Germany, Austria, Italy, Columbia,Iran and many more countries.</li>
<li>UG Courses offered: B.COM, B.B.M, Affiliated to University of Mysore for Duration of 6 semesters, Syllabus as per University of Mysore.</li>                            <li>Official transcripts (translated if not in English)</li>
                            <li>English Language courses are offered as per the requirement of international students</li>
                            <li>We also offer Dimploma in Short term courses. For More information Click Here</li>
                        <li>The Institute arranges for students' airport transfers.</li>
                            <li>Organizes accommodation facilities of International students.</li>
                            <li>Also helps students with the FRO registration and eligibility formalities.</li>
                            <li>Takes pleasure in assisting students to learn and know more about Mysore city, their new home.</li>
                            <li>The Institute also extends its support in international students' further studies if need be.</li>
                    </ul>
                    </div>
                </div>
                
                <div className="col-lg-6">
                    <div className="requirement-card">
                        <h5><i className="fa fa-passport text-primary me-2"></i>Visa & Documentation</h5>
                        <ul className="mt-3">
                            <li>The Institute also extends its support in international students' further studies if need be.</li>
                            <li>To get Student Visa you need an admission letter from us for which you have to pay registration fee</li>
                            <li>To apply for the admission, click here</li>
                        </ul>
                    </div>
                    
                </div>
            </div>
            
            <div className="text-center mt-5">
            </div>
        </div>
    </div>

    {/* <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3">Student Experiences</h6>
                <h1 className="mb-5">Hear From Our International Students</h1>
            </div>
            
            <div className="row g-4">
                <div className="col-lg-4">
                    <div className="student-testimonial">
                        <div className="d-flex align-items-center mb-3">
                            <img src="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" className="rounded-circle me-3" alt="Student" style={{width: "60px", height: "60px", objectFit: "cover"}}/>
                            <div>
                                <h5 className="mb-0">Maria Chen</h5>
                                <small>Computer Science, China</small>
                                <div className="d-flex">
                                    <img src="https://flagcdn.com/w20/cn.png" className="country-flag" alt="China Flag"/>
                                    <small>Beijing, China</small>
                                </div>
                            </div>
                        </div>
                        <p>"The international student office helped me with everything from visa to housing. The cultural exchange programs made me feel at home away from home."</p>
                    </div>
                </div>
                
                <div className="col-lg-4">
                    <div className="student-testimonial">
                        <div className="d-flex align-items-center mb-3">
                            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" className="rounded-circle me-3" alt="Student" style={{width: "60px", height: "60px", objectFit: "cover"}}/>
                            <div>
                                <h5 className="mb-0">Ahmed Hassan</h5>
                                <small>Business Administration, Egypt</small>
                                <div className="d-flex">
                                    <img src="https://flagcdn.com/w20/eg.png" className="country-flag" alt="Egypt Flag"/>
                                    <small>Cairo, Egypt</small>
                                </div>
                            </div>
                        </div>
                        <p>"The scholarship I received made it possible for me to study here. The career services helped me secure an internship that turned into a full-time job offer."</p>
                    </div>
                </div>
                
                <div className="col-lg-4">
                    <div className="student-testimonial">
                        <div className="d-flex align-items-center mb-3">
                            <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" className="rounded-circle me-3" alt="Student" style={{width: "60px", height: "60px", objectFit:" cover"}} />
                            <div>
                                <h5 className="mb-0">Sophie Laurent</h5>
                                <small>Environmental Science, France</small>
                                <div className="d-flex">
                                    <img src="https://flagcdn.com/w20/fr.png" className="country-flag" alt="France Flag" />
                                    <small>Paris, France</small>
                                </div>
                            </div>
                        </div>
                        <p>"As a graduate student, I appreciated the research opportunities and faculty mentorship. The multicultural environment enriched my academic experience."</p>
                    </div>
                </div>
            </div>
        </div>
    </div> */}

    <div className="container-fluid bg-light py-5">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-lg-10">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-light text-center text-primary px-3">Apply Now</h6>
                    <h1 className="mb-4">International Student Registration Form</h1>
                    {/* <p className="mb-5">Complete this form to begin your application process. Our admissions team will contact you within 48 hours with next steps.</p> */}
                </div>
                
                <div className="card border-0 shadow-lg">
                    <div className="card-body p-5">
                        <form id="internationalRegistrationForm">
                            <div className="mb-5">
                                <h4 className="text-primary mb-4"><i className="fa fa-user me-2"></i>Personal Information</h4>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="firstName" placeholder="First Name" required />
                                            <label for="firstName">First Name *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="lastName" placeholder="Last Name" required />
                                            <label for="lastName">Last Name *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="fathername" placeholder="Father Name" required />
                                            <label for="fathername">Father Name *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" id="email" placeholder="Email Address" required />
                                            <label for="email">Email Address *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="tel" className="form-control" id="phone" placeholder="Phone Number" />
                                            <label for="phone">Phone Number (with country code)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <select className="form-select" id="country" required>
                                                <option value="">Select Country</option>
                                                <option value="us">United States</option>
                                                <option value="ca">Canada</option>
                                                <option value="uk">United Kingdom</option>
                                                <option value="au">Australia</option>
                                                <option value="de">Germany</option>
                                                <option value="fr">France</option>
                                                <option value="jp">Japan</option>
                                                <option value="kr">South Korea</option>
                                                <option value="cn">China</option>
                                                <option value="in">India</option>
                                                <option value="br">Brazil</option>
                                                <option value="mx">Mexico</option>
                                                <option value="za">South Africa</option>
                                                <option value="ng">Nigeria</option>
                                                <option value="sa">Saudi Arabia</option>
                                                <option value="ae">United Arab Emirates</option>
                                                <option value="other">Other</option>
                                            </select>
                                            <label for="country">Country of Citizenship *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="date" className="form-control" id="dob" required />
                                            <label for="dob">Date of Birth *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="date" className="form-control" id="passport" placeholder="Passport Number" required />
                                            <label for="passport">Date of Arrival *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="passport" placeholder="Passport Number" required />
                                            <label for="passport">Passport Number *</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="postaladdress" required />
                                            <label for="postaladdress">Complete Postal Address*</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                                                        

                            <div className="text-center">
                                <button type="submit" className="btn btn-primary btn-lg py-3 px-5">
                                    <i className="fa fa-paper-plane me-2"></i>Submit Registration
                                </button>
                                {/* <p className="text-muted mt-3"><small>* Required fields. All information will be kept confidential.</small></p> */}
                            </div>
                        </form>
                        
                        <div id="successMessage" className="alert alert-success d-none" role="alert">
                            <h4 className="alert-heading"><i className="fa fa-check-circle me-2"></i>Registration Successful!</h4>
                            <p>Thank you for your registration. Our international admissions team will contact you within 48 hours with next steps.</p>
                            <br />
                            <p className="mb-0">A confirmation email has been sent to your registered email address.</p>
                        </div>
                    </div>
                </div>
                
                {/* <div className="row mt-5">
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body text-center">
                                <div className="feature-icon bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "70px", height: "70px"}}>
                                    <i className="fa fa-clock"></i>
                                </div>
                                <h5>Fast Processing</h5>
                                <p className="mb-0">Applications processed within 5-7 business days</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body text-center">
                                <div className="feature-icon bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "70px", height: "70px"}}>
                                    <i className="fa fa-headset"></i>
                                </div>
                                <h5>Dedicated Support</h5>
                                <p className="mb-0">Assigned admissions counselor for each applicant</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body text-center">
                                <div className="feature-icon bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "70px" ,height: "70px"}}>
                                    <i className="fa fa-shield-alt"></i>
                                </div>
                                <h5>Secure & Confidential</h5>
                                <p className="mb-0">SSL encrypted form with strict privacy protection</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    </div>
</div>
    </>
    )
}
export default InternationalStudents;